import type { FaireProductEntity } from "../../entity_types/product";

export const p_3sys3rschn: FaireProductEntity = {
  token: "p_3sys3rschn",
  type: "product",
  name: "Organic Fusilli Ancient Grain Pasta",
  brandToken: "b_cswuxgoe1w",
  brandName: "Bona Furtuna",
  imageUrl: "https://cdn.faire.com/fastly/8760a12bb14c7a5f40710b601287c63a905f13f274ec011347930cad8dae5eb1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f2e9047925a3bbbff8f68e1c03837028d96cffaea9edd0aea9571750dc69ea7b.jpeg",
    "https://cdn.faire.com/fastly/675f2910f00e6e15f0ee8faeee61831e737a8f45cfe5a043e730475d1f5b7779.jpeg",
    "https://cdn.faire.com/fastly/7349eac087ea7e3c91f7602f4b128f64da63cf47633cc8f96ec7f9be7547a839.jpeg",
    "https://cdn.faire.com/fastly/6831c4b62641c68a437c20175b9208439a294639e8fa368e1f44186efb4565e3.jpeg"
  ],
  priceDollars: 5.98,
  description: "At Bona Furtuna, we honor Sicilian history by marrying heirloom ingredients with modern technology. The distinctive corkscrew fusilli pasta shape is formed to trap bits of sauce in each twist, making fusilli the best pasta for pesto sauce. Our Sicilian Fusilli is 100% organic, non-GMO, and bronze died for robust flavor and texture.\n",
  tags: [],
  msrpDollars: 11.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:21.817Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
